import { jsonProperty, Serializable } from 'ts-serializable';

export class SurveyResultCommentFormModel extends Serializable {
  @jsonProperty(Object, null) comments: Record<number, string> = {};
}
